import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "orders",
  class: "flex flex-col gap-3 pb-[150px]"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute z-1 inset-0 flex items-center justify-center"
}
const _hoisted_3 = { class: "text-gray-500 w-40" }

import DoneCard from "@/components/done/DoneCard.vue";
import { ref } from "vue";
import store from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'DoneOverview',
  props: {
  orders: Array,
  readonly: {
    default: false,
  },
},
  setup(__props) {

const props = __props;

const activeOrder = ref(null as string | null);

const setActiveOrder = (index: string) => {
  activeOrder.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_unref(store)?.state?.OrderStore?.done.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orders, (order, index) => {
          return (_openBlock(), _createBlock(DoneCard, {
            key: index,
            index: index,
            order: order,
            readonly: __props.readonly,
            "active-order": activeOrder.value,
            onActiveOrder: setActiveOrder
          }, null, 8, ["index", "order", "readonly", "active-order"]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("done.empty")), 1)
      ]))
}
}

})